<div class="loyalty-hero">
  <!-- Capa oscura sobre la imagen de fondo -->
  <div class="hero-overlay"></div>

  <div class="content-wrapper">
    
    <!-- LADO IZQUIERDO: Branding y Copy -->
    <div class="brand-section">
      <!-- Aquí está tu logo alojado en AWS S3 -->
      <img src="https://loyalty-card-img.s3.us-east-1.amazonaws.com/rmnHub.jpeg" alt="rmm hub logo" class="brand-logo" />
      
      <h1 class="title">Tu lealtad<br><span class="highlight">tiene sabor.</span></h1>
      <p class="subtitle">Únete a nuestro club exclusivo. Acumula sellos con cada visita, disfruta de recompensas y lleva tu café favorito siempre contigo, directo en tu teléfono.</p>
    </div>

    <!-- LADO DERECHO: Tarjeta Interactiva de Cristal -->
    <div class="form-section">
      <div class="glass-card">
        <!-- Efecto de brillo tridimensional -->
        <div class="glass-reflection"></div>
        
        <!-- VISTA 1: FORMULARIO DE REGISTRO -->
        <ng-container *ngIf="!createdCard">
          <div class="card-header">
            <h2>Activa tu Membresía</h2>
            <p>Es gratis, rápida y 100% digital.</p>
          </div>

          <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="modern-form">
            <div class="input-container">
              <input type="text" formControlName="name" required autocomplete="off" />
              <label>Tu Nombre y Apellido</label>
              <div class="border-glow"></div>
            </div>

            <div class="input-container">
              <input type="tel" formControlName="phone" required autocomplete="off" />
              <label>Número de Teléfono</label>
              <div class="border-glow"></div>
            </div>
            <small class="hint">Dicta este número en caja para sumar tus sellos.</small>

            <button type="submit" [disabled]="registerForm.invalid || loading" class="btn-submit">
              <span *ngIf="!loading">Obtener Tarjeta Digital</span>
              <span *ngIf="loading" class="spinner"></span>
            </button>
          </form>
        </ng-container>

        <!-- VISTA 2: TARJETA CREADA CON ÉXITO -->
        <ng-container *ngIf="createdCard">
          
          <!-- Animación de Check -->
          <div class="success-animation">
            <div class="checkmark-circle">
              <div class="background"></div>
              <div class="checkmark draw"></div>
            </div>
          </div>
          
          <h2 class="success-title">¡Membresía Activa!</h2>
          
          <!-- Mini preview de la tarjeta VIP -->
          <div class="card-preview">
            <div class="preview-header">rmm hub VIP</div>
            <div class="preview-body">
              <div class="stamps-display">
                <span class="current">{{ createdCard.currentStamps }}</span>
                <span class="total">/ 10</span>
              </div>
              <p>Sellos acumulados</p>
            </div>
          </div>

          <p class="wallet-instruction">Guárdala ahora en tu billetera digital:</p>

          <div class="wallet-buttons">
            <button type="button" (click)="downloadAppleWallet()" class="btn-wallet apple">
              <svg viewBox="0 0 170 56"><text x="25" y="35" fill="#fff" font-size="16" font-family="-apple-system, sans-serif" font-weight="600">Add to Apple Wallet</text></svg>
            </button>

            <button type="button" (click)="openGoogleWallet()" class="btn-wallet google">
              <svg viewBox="0 0 170 56"><text x="25" y="35" fill="#fff" font-size="16" font-family="Roboto, sans-serif" font-weight="600">Save to Google Pay</text></svg>
            </button>
          </div>

          <button type="button" (click)="resetForm()" class="btn-reset">
            Crear otra tarjeta (Demo)
          </button>
        </ng-container>

      </div>
    </div>
  </div>
</div>
